import get from 'lodash/get'
import type { ApolloError} from '@apollo/client';
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client'

export type UseRoleProps = {
  roleName: string
}

export const query = gql(`
  query hasRole($name: String!) {
    hasRole(name: $name)
  }
`)

export type UseRoleResult = { hasRole: boolean; roleName: string; loading: boolean; error: ApolloError }
export const useRole = ({ roleName }: UseRoleProps): UseRoleResult => {
  const options: any = {
    skip: !roleName,
    variables: { name: roleName },
    fetchPolicy: 'cache-first',
    name: 'hasRole',
    nextFetchPolicy: 'cache-first',
  }

  const roleDocument = useQuery(query, options)
  const hasRole = get(roleDocument, 'data.hasRole', false)

  return {
    hasRole,
    roleName,
    loading: roleDocument?.loading ?? false,
    error: roleDocument?.error,
  }
}
